/* GRIPD Studio — theme JS
   Real Shopify cart via the AJAX Cart API. No prototype fakery:
   the drawer reflects /cart.js, quantity changes hit /cart/change.js,
   and Checkout goes to Shopify's hosted checkout. */

(function () {
  'use strict';

  var cfg = window.GRIPD || {};
  var money = function (cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    // Trim a trailing .00 so $26.00 reads as $26, matching the prototype
    if (amount.slice(-3) === '.00') amount = amount.slice(0, -3);
    return fmt.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, amount);
  };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- overlay / modals ---------- */
  function el(id) { return document.getElementById(id); }
  function overlay(on) {
    var o = el('overlay');
    if (o) o.classList.toggle('open', !!on);
  }
  function closeAll() {
    ['sizechart', 'welcome'].forEach(function (id) {
      var n = el(id);
      if (n) n.classList.remove('open');
    });
    var d = el('drawer');
    if (d) d.classList.remove('open');
    overlay(false);
  }
  function toggleSizeChart(on) {
    var n = el('sizechart');
    if (!n) return;
    n.classList.toggle('open', on);
    overlay(on);
  }

  /* ---------- cart ---------- */
  var cartState = null;

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; return c; });
  }

  function setCount(n) {
    document.querySelectorAll('.cartcount').forEach(function (e) { e.textContent = n; });
  }

  function renderDrawer(cart) {
    var items = el('drawer-items');
    var foot = el('drawer-foot');
    if (!items || !foot) return;
    setCount(cart.item_count);

    if (!cart.item_count) {
      items.innerHTML =
        '<div class="empty">' + (cfg.strings && cfg.strings.emptyTitle ? cfg.strings.emptyTitle : 'Your bag is empty.') +
        '<br>Grip something good.</div>';
      foot.innerHTML = '';
      return;
    }

    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var opts = (it.options_with_values || [])
        .map(function (o) { return o.value; })
        .join(' · ');
      return '' +
        '<div class="ci" data-key="' + it.key + '">' +
          (img ? '<img src="' + img + '" alt="' + escapeHtml(it.product_title) + '">' : '<div style="width:72px;height:90px;border-radius:10px;background:var(--grey)"></div>') +
          '<div>' +
            '<div class="n">' + escapeHtml(it.product_title) + '</div>' +
            '<div class="m">' + escapeHtml(opts) + '</div>' +
            '<div class="qty">' +
              '<button type="button" data-ch="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-ch="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="p">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    var threshold = cfg.freeShipThreshold || 0;
    var sub = cart.total_price;
    var pct = threshold ? Math.min(100, Math.round((sub / threshold) * 100)) : 100;
    var remaining = Math.max(0, threshold - sub);

    foot.innerHTML = '' +
      (threshold ?
        '<div class="freebar"><i style="width:' + pct + '%"></i></div>' +
        '<div class="freemsg">' + (remaining === 0
          ? '&#127881; You&rsquo;ve unlocked free shipping!'
          : 'You&rsquo;re ' + money(remaining) + ' away from free shipping') + '</div>'
        : '') +
      '<div class="subrow"><span>Subtotal</span><span>' + money(sub) + '</span></div>' +
      '<div class="subnote">Shipping &amp; taxes calculated at checkout</div>' +
      '<form action="/cart" method="post"><button class="btn" style="width:100%" type="submit" name="checkout">Checkout</button></form>';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openDrawer(on) {
    var d = el('drawer');
    if (!d) return;
    if (on) {
      fetchCart().then(function (c) {
        renderDrawer(c);
        d.classList.add('open');
        overlay(true);
      });
    } else {
      d.classList.remove('open');
      overlay(false);
    }
  }

  function changeLine(key, delta) {
    var item = (cartState && cartState.items || []).filter(function (i) { return i.key === key; })[0];
    if (!item) return;
    var qty = Math.max(0, item.quantity + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; renderDrawer(c); })
      .catch(function () { toast('Could not update the bag'); });
  }

  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Add failed'); });
      return r.json();
    });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (t) { e.preventDefault(); openDrawer(true); return; }

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); openDrawer(false); return; }

    var ch = e.target.closest('[data-ch]');
    if (ch) {
      e.preventDefault();
      var row = ch.closest('.ci');
      if (row) changeLine(row.getAttribute('data-key'), parseInt(ch.getAttribute('data-ch'), 10));
      return;
    }

    if (e.target.closest('[data-sizechart-open]')) { e.preventDefault(); toggleSizeChart(true); return; }
    if (e.target.closest('[data-sizechart-close]')) { e.preventDefault(); toggleSizeChart(false); return; }
    if (e.target.closest('[data-welcome-close]')) { e.preventDefault(); closeWelcome(); return; }

    var acc = e.target.closest('.acc-head');
    if (acc) { acc.parentNode.classList.toggle('open'); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------- product form ---------- */
  function initProductForm(root) {
    var form = root.querySelector('[data-product-form]');
    if (!form) return;

    var variants = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add-btn]');
    var priceEl = root.querySelector('[data-price]');
    var qtyEl = root.querySelector('[data-qty-value]');
    var selected = null;
    var qty = 1;

    function label() {
      if (!selected) return 'Add to bag';
      if (!selected.available) return 'Sold out';
      var total = selected.price * qty;
      return qty > 1 ? 'Add ' + qty + ' to bag — ' + money(total) : 'Add to bag';
    }
    function sync() {
      addBtn.textContent = label();
      addBtn.disabled = !!(selected && !selected.available);
      if (priceEl && selected) priceEl.textContent = money(selected.price);
      if (qtyEl) qtyEl.textContent = qty;
    }

    root.querySelectorAll('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        root.querySelectorAll('[data-size]').forEach(function (o) { o.classList.remove('on'); });
        b.classList.add('on');
        var vid = parseInt(b.getAttribute('data-variant-id'), 10);
        selected = variants.filter(function (v) { return v.id === vid; })[0] || null;
        if (idInput) idInput.value = vid;
        sync();
      });
    });

    root.querySelectorAll('[data-qty-ch]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, Math.min(10, qty + parseInt(b.getAttribute('data-qty-ch'), 10)));
        sync();
      });
    });

    // Auto-select if there is only one variant
    var avail = variants.filter(function (v) { return v.available; });
    if (variants.length === 1) {
      selected = variants[0];
      if (idInput) idInput.value = selected.id;
      var only = root.querySelector('[data-size]');
      if (only) only.classList.add('on');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!selected) { toast('Pick a size first'); return; }
      if (!selected.available) { toast('That size is sold out'); return; }
      addBtn.disabled = true;
      addVariant(selected.id, qty)
        .then(function () {
          toast(qty > 1 ? 'Added ' + qty + ' pairs to bag' : 'Added to bag');
          openDrawer(true);
        })
        .catch(function (err) { toast(err.message || 'Could not add to bag'); })
        .finally(function () { addBtn.disabled = false; sync(); });
    });

    sync();
  }

  /* ---------- product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    if (!main) return;
    root.querySelectorAll('[data-gallery-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        main.src = th.getAttribute('data-full');
        root.querySelectorAll('[data-gallery-thumb]').forEach(function (o) { o.classList.remove('on'); });
        th.classList.add('on');
      });
    });
  }

  /* ---------- hero carousel ---------- */
  function initHero(root) {
    var slides = [].slice.call(root.querySelectorAll('.hero-slide'));
    if (slides.length < 1) return;
    var dots = root.querySelector('[data-hero-dots]');
    var idx = 0, timer;

    if (dots && slides.length > 1) {
      dots.innerHTML = slides.map(function (_, i) {
        return '<button type="button" data-hero-go="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>';
      }).join('');
    }

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('on', j === idx); });
      if (dots) {
        [].slice.call(dots.children).forEach(function (d, j) { d.classList.toggle('on', j === idx); });
      }
      clearInterval(timer);
      if (slides.length > 1) timer = setInterval(function () { go(idx + 1); }, 5000);
    }

    root.addEventListener('click', function (e) {
      var g = e.target.closest('[data-hero-go]');
      if (g) { go(parseInt(g.getAttribute('data-hero-go'), 10)); return; }
      if (e.target.closest('[data-hero-prev]')) { go(idx - 1); return; }
      if (e.target.closest('[data-hero-next]')) { go(idx + 1); return; }
    });

    go(0);
  }

  /* ---------- welcome popup ---------- */
  function closeWelcome() {
    var w = el('welcome');
    if (w) w.classList.remove('open');
    overlay(false);
    try { sessionStorage.setItem('gripd_welcome', '1'); } catch (err) { /* private mode */ }
  }
  function initWelcome() {
    var w = el('welcome');
    if (!w) return;
    var seen = false;
    try { seen = sessionStorage.getItem('gripd_welcome') === '1'; } catch (err) { seen = false; }
    if (seen) return;
    var delay = parseInt(w.getAttribute('data-delay') || '2', 10) * 1000;
    setTimeout(function () {
      if (document.querySelector('.drawer.open')) return;
      w.classList.add('open');
      overlay(true);
    }, delay);
  }

  /* ---------- marquee ---------- */
  function initMarquee(root) {
    var inner = root.querySelector('[data-marquee-inner]');
    if (!inner) return;
    inner.innerHTML = inner.innerHTML + inner.innerHTML;
  }

  /* ---------- boot ---------- */
  function boot() {
    document.querySelectorAll('[data-product-root]').forEach(function (r) {
      initProductForm(r);
      initGallery(r);
    });
    document.querySelectorAll('[data-hero]').forEach(initHero);
    document.querySelectorAll('[data-marquee]').forEach(initMarquee);
    initWelcome();
    fetchCart().then(function (c) { setCount(c.item_count); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    t.querySelectorAll('[data-product-root]').forEach(function (r) { initProductForm(r); initGallery(r); });
    t.querySelectorAll('[data-hero]').forEach(initHero);
    t.querySelectorAll('[data-marquee]').forEach(initMarquee);
  });

  window.GripdUI = {
    closeAll: closeAll,
    openDrawer: openDrawer,
    toggleSizeChart: toggleSizeChart,
    closeWelcome: closeWelcome,
    toast: toast
  };
})();
